import './host'

import { MailingService } from '@graft/nuget-gc.webportals.mailing'

import { getSessionToken } from '@common/helpers'
import { isVisionLocal } from '@common/utils/isVisionLocal'

import type { FeedbackPayload } from './mailing.type'

export async function sendFeedbackEmail(payload: FeedbackPayload): Promise<void> {
  try {
    if (isVisionLocal()) {
      return
    }

    const token = await getSessionToken()
    const { topic, message, rating } = payload

    await MailingService.sendFeedbackEmail(token, topic, message, rating)
  } catch (error) {
    console.error('Failed to send feedback email:', error)
  }
}
